module.exports = __webpack_public_path__ + "img/Tigre_completed.ffefbc72.svg";